var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.942,
    height: 79.942,
    viewBox: "0 0 79.942 79.942",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18617",
    "data-name": "Group 18617",
    transform: "translate(3554 -2067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M39.971,0A39.971,39.971,0,1,1,0,39.971,39.971,39.971,0,0,1,39.971,0Z",
    transform: "translate(-3554 2067)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Email_2770972",
    transform: "translate(-3530.516 2093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M59.416,40.225c-.49-7.083-6.794-12.923-14.779-13.669a17.722,17.722,0,0,0-13.308,4.225,13.671,13.671,0,0,0-4.763,11.8c.77,6.9,7,12.364,14.779,13.047a15.205,15.205,0,0,0,1.681.062,17.148,17.148,0,0,0,9.106-2.485,1.3,1.3,0,0,0,.42-1.926,1.7,1.7,0,0,0-2.171-.373,14.494,14.494,0,0,1-8.685,1.926c-6.3-.559-11.277-4.97-11.908-10.562a10.991,10.991,0,0,1,3.852-9.568A14.412,14.412,0,0,1,44.427,29.29c6.444.559,11.557,5.281,11.908,11.059a11.055,11.055,0,0,1-.7,4.535,3.032,3.032,0,0,1-2.872,1.8,2.836,2.836,0,0,1-3.012-2.672v-8.76a1.544,1.544,0,0,0-1.611-1.429,1.5,1.5,0,0,0-1.611,1.429v.435a8.02,8.02,0,0,0-4.413-1.243c-4.133-.062-7.565,2.982-7.565,6.648s3.362,6.71,7.565,6.71a8.137,8.137,0,0,0,4.9-1.615,6.38,6.38,0,0,0,5.674,3.355,6.293,6.293,0,0,0,5.884-3.666A15.646,15.646,0,0,0,59.416,40.225Zm-17.3,4.784A4.168,4.168,0,0,1,37.7,41.095a4.168,4.168,0,0,1,4.413-3.914,4.168,4.168,0,0,1,4.413,3.914A4.213,4.213,0,0,1,42.115,45.009Z",
    transform: "translate(-26.484 -26.484)",
    fill: "#91a0a0"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.6b866aba.svg";
export { ForwardRef as ReactComponent };